import React from 'react'
import Sidebar from './Sidebar'
import { Box } from '@mui/material'
export default function Request() {
  return (
    <Box sx={{display:"flex"}}> 
      <Sidebar />
      <Box  className="boxStyle">
        <div className="mt-3" >
          <h2 className='text-danger'>This is Request page</h2>
        </div>
      </Box>
    </Box>
  )
}
